import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

/**
 * Group title band: dark mode uses elevated card surface; light mode uses a light primary wash (Zporti purple).
 */
function groupCardHeaderBackground(theme: Theme): string {
  if (theme.background.card === theme.background.cardElevated) {
    return theme.primary + '14';
  }
  return theme.background.cardElevated;
}

export const getWorldCupGroupStageTableCardStyles = (theme: Theme) =>
  StyleSheet.create({
    card: {
      borderRadius: 14,
      backgroundColor: theme.background.card,
      borderWidth: StyleSheet.hairlineWidth,
      borderColor: theme.gray[200],
      overflow: 'hidden',
      marginBottom: 12,
    },
    cardHeader: {
      paddingVertical: 10,
      paddingHorizontal: 16,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: theme.gray[200],
      backgroundColor: groupCardHeaderBackground(theme),
    },
    groupTitle: {
      fontSize: 13,
      fontWeight: '800',
      letterSpacing: 1.6,
      color: theme.gray[800],
    },
    tableBody: {
      width: '100%',
      alignSelf: 'stretch',
      paddingBottom: 4,
    },
    headerRow: {
      flexDirection: 'row',
      alignItems: 'center',
      alignSelf: 'stretch',
      width: '100%',
      paddingHorizontal: 16,
      paddingTop: 8,
      paddingBottom: 6,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: theme.gray[200],
    },
    dataRow: {
      flexDirection: 'row',
      alignItems: 'center',
      alignSelf: 'stretch',
      width: '100%',
      paddingVertical: 8,
      paddingHorizontal: 16,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: theme.gray[300] + '40',
    },
    dataRowLast: {
      borderBottomWidth: 0,
    },
    rowQualified: {
      backgroundColor: theme.primary + '14',
    },
    rowPossibleThird: {
      backgroundColor: theme.accent + '14',
    },
    positionBar: {
      width: 4,
      height: 16,
      borderRadius: 2,
      marginRight: 8,
    },
    positionBarQualified: {
      backgroundColor: theme.primary,
    },
    positionBarPossible3rd: {
      backgroundColor: theme.accent + '99',
    },
    positionBarEliminated: {
      backgroundColor: 'transparent',
    },
    colTeam: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      minWidth: 0,
      paddingRight: 4,
    },
    teamName: {
      flex: 1,
      flexShrink: 1,
      minWidth: 0,
      fontSize: 11,
      fontWeight: '700',
      color: theme.gray[800],
    },
    colStat: {
      width: 28,
      alignItems: 'center',
    },
    colGd: {
      width: 36,
      alignItems: 'center',
    },
    colPts: {
      width: 34,
      alignItems: 'center',
    },
    headerText: {
      fontSize: 11,
      fontWeight: '600',
      color: theme.gray[500],
      textAlign: 'center',
    },
    headerTextTeam: {
      fontSize: 11,
      fontWeight: '600',
      color: theme.gray[500],
    },
    headerTextPts: {
      fontSize: 11,
      fontWeight: '800',
      color: theme.gray[800],
      textAlign: 'center',
    },
    cellText: {
      fontSize: 12,
      fontWeight: '500',
      color: theme.gray[600],
      textAlign: 'center',
    },
    cellGdPositive: {
      fontSize: 12,
      fontWeight: '700',
      color: theme.success,
      textAlign: 'center',
    },
    cellGdNegative: {
      fontSize: 12,
      fontWeight: '700',
      color: theme.error,
      textAlign: 'center',
    },
    cellGdZero: {
      fontSize: 12,
      fontWeight: '700',
      color: theme.gray[500],
      textAlign: 'center',
    },
    cellPts: {
      fontSize: 12,
      fontWeight: '800',
      color: theme.gray[800],
      textAlign: 'center',
    },
    legend: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 12,
      paddingVertical: 6,
      paddingHorizontal: 16,
      borderTopWidth: StyleSheet.hairlineWidth,
      borderTopColor: theme.gray[300] + '55',
    },
    legendItem: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 4,
    },
    legendDot: {
      width: 6,
      height: 6,
      borderRadius: 3,
    },
    legendDotQualified: {
      backgroundColor: theme.primary,
    },
    legendDotPossible: {
      backgroundColor: theme.accent + '99',
    },
    legendText: {
      fontSize: 9,
      fontWeight: '500',
      color: theme.gray[500],
    },
  });
